import * as React from 'react';
import ReactSelect from 'react-select';
import { useFiltersContext } from '../../contexts/filters';
import { ITaxonomy } from '../../types';

interface IProps {
	taxonomy: ITaxonomy;
}

interface ISelectOption {
	label: string;
	value: string;
}

const Select = ({ taxonomy }: IProps) => {
	let options = taxonomy.terms.map((term) => {
		// decode htmlentities.
		const label = document.createElement('textarea');
		label.innerHTML = term.name;

		return {
			label: label.value,
			value: '' + term.term_id,
		};
	});

	options = [{ label: `All ${taxonomy.labels.name}`, value: '' }, ...options];

	const { selectedTax, selectTaxTerm } = useFiltersContext();
	const [value, setValue] = React.useState(options[0]);

	const prevValue = React.useRef(options[0].value);
	const handleOnChange = (option: ISelectOption | null) => {
		if (null !== option && prevValue.current !== option.value && selectTaxTerm) {
			setValue(option);
			selectTaxTerm(taxonomy.name, +option.value);

			prevValue.current = option.value;
		}
	};

	// When filters are reset, set our value back to the first option.
	React.useEffect(() => {
		if (!Object.values(selectedTax).length) {
			setValue(options[0]);
		}
	}, [selectedTax]);

	return (
		<>
			<p>Select</p>
			<ReactSelect
				className="pfa-filter-select"
				classNamePrefix="pfa-filter-select"
				options={options}
				onChange={handleOnChange}
				value={value}
				key={taxonomy.name}
			/>
		</>
	);
};

Select.displayName = 'Select';

export default Select;
